const authConstant = require("./constant");
const axios = require("axios").default;
const _ = require("lodash");

const getKMReport = async (sdt, edt) => {
  const authToken = localStorage.getItem("auth-token");
  const response = await axios.post(
    authConstant.MAIN_URI,
    {
      name: "getMileageReport",
      param: {
        usr: localStorage.getItem("username"),
        sdt,
        edt
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          `Bearer ${authToken}`,
      },
    }
  );
  return _.result(response.data, "response.result");
};

export default getKMReport;
